import { SelectStatementColumn } from './../../models/select-statement-column.model';
import { QueryFilterParameter } from './../../widgets/filters/models/query-filter-parameter.model';
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/services/base.service";
import { Observable } from "rxjs";
import { HtmlControlType } from "src/app/enums/htmlControlType";
import { DynamicTable } from "src/app/models/dynamicTable";

@Injectable({
  providedIn: "root",
})
export class StockService {
  constructor(private baseService: BaseService) { }


  public getOverviewData(OverviewFiltersOutput:OverviewFiltersOutput): Observable<OverviewDataDto>{
		let url = `stock/GetDataOverview`;
		return this.baseService.post(url,OverviewFiltersOutput);
	}


  public getHeatMapData(OverviewFiltersOutput:OverviewFiltersOutput): Observable<any>{
		let url = `stock/GetStockControlHeatMap`;
		return this.baseService.post(url,OverviewFiltersOutput);
	}


  public getHeatMapFilters(filters: QueryFilterParameter[]): Observable<OverviewFilterInput[]>{
		let url = `stock/GetHeatMapFilters`;
		return this.baseService.post(url,filters);
	}


  public getIssueDevelopmentFilters(filters: QueryFilterParameter[]): Observable<OverviewFilterInput[]>{
		let url = `stock/GetIssueDevelopmentFilters`;
		return this.baseService.post(url,filters);
	}

  

  public getOverviewFilters(filters: QueryFilterParameter[]): Observable<OverviewFilterInput[]>{
		let url = `stock/GetOverviewFilters`;
		return this.baseService.post(url,filters);
	}

  getDeepDiveAutocomleteData(objectId: string): Observable<string[]> {
    const url = `stock/GetAutoComplete?objectId=${objectId}`;
    return this.baseService.get(url);
  }

  getDeepDiveDropdownData(
    listId: string
  ): Observable<DeepDiveDropdownElement[]> {
    const url = `stock/GetDropdownValue?listId=${listId}`;
    return this.baseService.get(url);
  }

  getDeepDiveData(action: string,itemId:string): Observable<DeepDiveProductsTable> {
    let url = `stock/GetOverviewDeepDive?action=${action}&itemId=${encodeURIComponent(itemId)}`;
    return this.baseService.get(url);
  }

  getStockControllingDeepDiveProductDetails(productId: string): Observable<DeepDiveData> {

    return this.baseService.post("stock/GetProductDetails",{id:productId});
  }

  updateDeepDiveRootCause(data: UpdateRootCauseOuput): Observable<any> {
    const url = `stock/UpdateRootCause`;
    return this.baseService.post(url, data);
  }

  getIssueData(action: string): Observable<IssueData> {
    const url = `stock/GetIssueData?action=${action}`;
    return this.baseService.get(url);
  }


  public getIssueDataNew(OverviewFiltersOutput:OverviewFiltersOutput): Observable<any>{
		let url = `stock/GetIssueDataNew`;
		return this.baseService.post(url,OverviewFiltersOutput);
	}

  public getHeadMapData(ValidFilters:ValidFilters): Observable<HeatMap>{
		let url = `stock/GetStockControlHeatMap`;
		return this.baseService.post(url,ValidFilters);
	}

}

//overview objects
export class OverviewFiltersOutput {
  settingGroupId?: number;
  filters: QueryFilterParameter[] = [];
  action: string; 
}

export class OverviewFilterOutput {
  selectionId: number;
  fieldValue: string;
}
export class OverviewFilterInput {
  displayName: string;
  selectionId: number;
  selectionName: string;
  defaultFilterValue: string; 
  orderBy: number;
  htmlControlType: HtmlControlType;
  values: any;
  selectedValues: string[];
	selectionMode: 'multiple' | 'single';
	instantSelectionApplication: boolean;
	isVisible: boolean;
}

export class OverviewDataDto {
  stockDevelopmentChart: OverviewDevelopmentChart[];
  stockControllingData: OverviewTable[];
  unitOfMeasureData: OverviewUnitOfMeasure[];
}

export class OverviewDevelopmentChart {
  stockAmount: number | null;
  stockCtrEsoLine: number | null;
  yearWeek: string;
}

export class OverviewTable {
  constructor(
    count: number | null,
    avgStockAmount: number | null,
    inbound: number | null,
    avgStockSimulatedAmount: number | null,
    avgDiffAmount: number | null,
    issue: string
  ) {
    (this.count = count),
      (this.avgStockAmount = avgStockAmount),
      (this.inbound = inbound),
      (this.avgStockSimulatedAmount = avgStockSimulatedAmount),
      (this.avgDiffAmount = avgDiffAmount),
      (this.issue = issue);
  }
  count: number | null;
  avgStockAmount: number | null;
  inbound: number | null;
  avgStockSimulatedAmount: number | null;
  avgDiffAmount: number | null;
  issue: string;
}

export class OverviewUnitOfMeasure {
  contentName: string;
  contentValue: string;
  contentId: number;
}


//deep-dive objects

export class DeepDiveDdlData {
  id: number;
  action: string;
}

export class DeepDiveDropdownElement {
  listElementId: number;
  listElement: string;
}

export class DeepDiveData {
  access: ReturnFlag[]; 
  deepDives: DeepDiveChartsData[];
  esoDeepDives: DeepDiveDetailsTable[];
  esoDeepDiveIssues: DeepDiveDetailsIssuesTable;
  stockDeepDiveChartCaption:StockDeepDiveChartCaption[];
}

export class DeepDiveChartsData {
  yearWeek: string;
  forecast: number;
  fCerror: number;
  actualStock: number;
  simulStock: number;
  actual: number;
  production: number;
  adjustment: number;
  stockout: number;
  safetyStock: number;
  simulLotsize: number;
}

export class DeepDiveBase {
  lotSize: number;
  esoObjectId: number;
  lastRootCause: string;
  lastPeritoComments: string;
  lastRootCauseComment: string;
}

export class DeepDiveDetailsTable extends DeepDiveBase {
  actual: number;
  leadTime: number;
  simulated: number;
  difference: number;
  inboundQty: number;
  actualStock: number;
  safetyStock: number;
  rootCause: string;
  rootCauseComment: string;
  headerTitle: string; 
  currentStockControllingId: string; 
  secondHeaderName: string; 
}

export class DeepDiveDetailsIssuesTable {
  items: DeepDiveDetailsIssueItem[];
}

export class DeepDiveDetailsIssueItem {
  fieldName: string;
  caption: string;
  value: any;
  dataFormat:string;
  dataType:string;
}

export class StockDeepDiveChartCaption{
  fieldName: string;
  caption: string;
  orderBy: number; 
}
export class DeepDiveProductsTable {
  fields: DeepDiveColumnData[];
  values: [];
  total: number;
}

export class DeepDiveRowData {
  stockId: number | null;
  esoObjectId: number | null;
  yearWeek: number | null;
  stockSimulatedAmount: number | null;
  stockAmount: number | null;
  stockLYAmount: number | null;
  stockCtrEsoLine: number | null;
  productId: string;
  esoObjectGroup2: string;
  esoObjectGroup3: string;
  esoObjectGroup4: string;
  esoObjectGroup5: string;
  esoObjectGroup: string;
  issue: string;
  avgStockAmount: number | null;
  avgStockSimulatedAmount: number | null;
  avgDiffAmount: number | null;
  count: number | null;
  sales: number | null;
  salesLY: number | null;
  forecast: number | null;
  esoObjectGroup6: string;
  esoObjectGroup7: string;
  esoObjectGroup14: string;
  inbound: number | null;
  esoObjectGroup8: string;
  esoObjectGroup9: string;
  esoObjectGroup10: string;
  esoObjectGroup11: string;
  esoObjectGroup12: string;
  esoObjectGroup13: string;
  esoObjectGroup15: string;
  esoObjectGroup16: string;
  esoObjectGroup17: string;
  esoObjectGroup18: string;
  esoObjectGroup19: string;
  esoObjectGroup20: string;
  esoObjectGroup21: string;
  esoObjectGroup22: string;
  esoObjectGroup23: string;
  esoObjectGroup24: string;
  esoObjectGroup25: string;
  esoObjectGroup26: string;
  esoObjectGroup27: string;
  esoObjectGroup28: string;
  esoObjectGroup29: string;
  esoObjectGroup30: string;
  esoObjectGroup31: string;
  esoObjectGroup32: string;
  esoObjectGroup33: string;
  esoObjectGroup34: string;
  esoObjectGroup35: string;
  esoObjectGroup36: string;
  esoObjectGroup37: string;
  esoObjectGroup38: string;
  esoObjectGroup39: string;
  esoObjectGroup40: string;
  esoObjectGroup41: string;
  esoObjectGroup42: string;
  esoObjectGroup43: string;
  esoObjectGroup44: string;
  esoObjectGroup45: string;
  esoObjectGroup46: string;
  esoObjectGroup47: string;
  esoObjectGroup48: string;
  esoObjectGroup49: string;
  esoObjectGroup50: string;

  invDiffAmount: number | null;
  actualStock: string;
  issueOLd: string;
  rootCause: string;
  lastRootCause: string;
}

export class DeepDiveColumnData {
  fieldName: string;
  caption: string;
  dataType:string;
  dataFormat:string;
}

export class DeepDiveParamsTable {
  title: any;
  desc: any;
}

export class UpdateRootCauseOuput {
  productId: string;
  rootCause: string;
  rootCauseComment: string;
}

//issue
export class IssueData {
  chartData: IssueDataChart[] = [];
  tableData: IssueDataTable;
}

export class IssueDataChart {
  oldIssue: string;
  newIssue: string;
  totalCount: number;
}

export class IssueDataTable {
  captions: SelectStatementColumn[];
  data: DynamicTable;
}

//Heat Map
export class HeatMap {
  captions: SelectStatementColumn[];
  data: DynamicTable;
}

export interface DrillInfo {
  text: string;
  node?: any;
}

export interface ColorizationOption {
  name: string;
  options: any;
}

export class TaskData {
  SettingId: number;
  SettingValue: string;
  FieldName: string; 
}

export class TaskDataFilter {
  settingId: number;
  settingValue: string;
  fieldName: string; 
}

export class ReturnFlag {
  flag: number;
  msg: string;
  retrunData: string; 
}

export class ValidFilters { 
  filters: QueryFilterParameter[] = [];
  action: string;
}
